// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mb-cancel-buttons[data-v-2de6a63e]{display:flex;flex-direction:column;padding-bottom:2rem;padding-top:1.5rem}@media (min-width:768px){.mb-cancel-buttons[data-v-2de6a63e]{flex-direction:row}.mb-cancel-buttons__button[data-v-2de6a63e]{width:15rem}}.mb-cancel-buttons__button--first[data-v-2de6a63e]{margin-top:1rem;order:2}@media (min-width:768px){.mb-cancel-buttons__button--first[data-v-2de6a63e]{margin-right:.75rem;margin-top:0;order:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
